import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-col-12 p-md-5 p-d-flex p-ai-center p-jc-center p-flex-wrap" }
const _hoisted_2 = { class: "p-col-12 p-m-0 p-text-center" }
const _hoisted_3 = { class: "p-fluid p-col-12 p-md-10" }
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = { for: "category" }
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = { for: "reference" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = { for: "name" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = { for: "purchaseCost" }
const _hoisted_14 = { class: "p-col-12 p-md-2" }
const _hoisted_15 = { class: "p-d-flex p-flex-column p-ai-center" }
const _hoisted_16 = { class: "p-mt-2" }
const _hoisted_17 = { class: "p-col-12 p-md-5 p-d-flex p-ai-center p-jc-center p-flex-column" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "p-fluid p-col-12"
}
const _hoisted_20 = { class: "p-m-0 p-text-center" }
const _hoisted_21 = { class: "p-field" }
const _hoisted_22 = { for: "quantity" }
const _hoisted_23 = { class: "p-field" }
const _hoisted_24 = { for: "expiredAt" }
const _hoisted_25 = { class: "p-field" }
const _hoisted_26 = { for: "alertAt" }
const _hoisted_27 = { class: "p-field" }
const _hoisted_28 = { for: "threshold" }
const _hoisted_29 = { class: "p-col-12" }
const _hoisted_30 = { class: "p-col-6" }
const _hoisted_31 = { class: "p-col-6" }

import { computed } from "vue";
import { numberSeparators } from "@/graphql/utils/utils";
import { activeActivity, subscriptionExpired } from "@/plugins/i18n";
import { useCreateProduct } from "@/graphql/product/create.product";
import PriceInput from "@/components/product/PriceInput.vue";
import ImageCropper from "@/components/common/ImageCropper.vue";
import { canNavigateAnywhere, getAccess } from "@/utils/activity";
import { Category, EAccessMenu } from "@/graphql/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateProduct',
  props: {
    categories: { default: () => [] }
  },
  setup(__props: any) {



const acc = getAccess(EAccessMenu.Product);
const noRestriction = canNavigateAnywhere();
const notExpired = !subscriptionExpired();
const minDate = new Date();
const { form, submitCreation, loading, image, resetFields, cropperRef } =
  useCreateProduct();

const canCreate = computed(() => {
  return (acc?.create || noRestriction) && notExpired && !loading.value;
});

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createBlock(_component_BlockUI, {
    blocked: !canCreate.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        autocomplete: "off",
        onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_unref(submitCreation) && _unref(submitCreation)(...args)), ["prevent"])),
        class: "p-grid"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("product.general")), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("product.category")), 1),
              _createVNode(_component_Dropdown, {
                modelValue: _unref(form).categoryId.$value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).categoryId.$value) = $event)),
                options: _ctx.categories,
                filter: true,
                optionLabel: "label",
                "filter-fields": ['label'],
                "scroll-height": "150px",
                "empty-filter-message": _ctx.$t('noResult'),
                id: "category",
                "data-key": "id",
                "option-value": "id"
              }, null, 8, ["modelValue", "options", "empty-filter-message"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.$t("product.reference")) + " ", 1),
                _hoisted_8
              ]),
              _createVNode(_component_InputText, {
                modelValue: _unref(form).reference.$value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).reference.$value) = $event)),
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_unref(form).reference.$validate())),
                class: _normalizeClass({ 'p-invalid': _unref(form).reference.$hasError }),
                id: "reference"
              }, null, 8, ["modelValue", "class"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.$t("product.name")) + " ", 1),
                _hoisted_11
              ]),
              _createVNode(_component_InputText, {
                modelValue: _unref(form).name.$value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).name.$value) = $event)),
                id: "name",
                type: "text",
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (_unref(form).name.$validate())),
                class: _normalizeClass({ 'p-invalid': _unref(form).name.$hasError })
              }, null, 8, ["modelValue", "class"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("product.purchaseCost")), 1),
              _createVNode(_component_InputNumber, {
                modelValue: _unref(form).notStorableInput.purchasePrice.$value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).notStorableInput.purchasePrice.$value) = $event)),
                locale: _unref(numberSeparators)[_unref(activeActivity).separator],
                "max-fraction-digits": 20,
                "allow-empty": false,
                min: 0,
                id: "purchaseCost",
                mode: "decimal"
              }, null, 8, ["modelValue", "locale"])
            ]),
            _createVNode(PriceInput, {
              exclTax: _unref(form).notStorableInput.exclTax.$value,
              "onUpdate:exclTax": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).notStorableInput.exclTax.$value) = $event)),
              inclTax: _unref(form).notStorableInput.inclTax.$value,
              "onUpdate:inclTax": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).notStorableInput.inclTax.$value) = $event)),
              vat: _unref(form).notStorableInput.vat.$value,
              "onUpdate:vat": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).notStorableInput.vat.$value) = $event))
            }, null, 8, ["exclTax", "inclTax", "vat"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Divider, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_InputSwitch, {
                  modelValue: _unref(form).type.$value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).type.$value) = $event)),
                  "true-value": 0,
                  "false-value": 1
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$tm("product.storable")), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_unref(form).type.$value === 1)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_18, _toDisplayString(_ctx.$t("product.create.notStorable")), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.$t("product.create.storable")), 1),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("product.quantity")), 1),
                  _createVNode(_component_InputNumber, {
                    modelValue: _unref(form).stockInput.quantity.$value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).stockInput.quantity.$value) = $event)),
                    locale: _unref(numberSeparators)[_unref(activeActivity).separator],
                    "allow-empty": false,
                    "max-fraction-digits": 20,
                    min: 0,
                    id: "quantity",
                    mode: "decimal"
                  }, null, 8, ["modelValue", "locale"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("product.expiredAt")), 1),
                  _createVNode(_component_Calendar, {
                    modelValue: _unref(form).stockInput.expiredAt.$value,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).stockInput.expiredAt.$value) = $event)),
                    dateFormat: _ctx.$t('format.calShort'),
                    placeholder: _ctx.$t('format.calShort'),
                    "year-navigator": true,
                    id: "expiredAt",
                    "min-date": _unref(minDate)
                  }, null, 8, ["modelValue", "dateFormat", "placeholder", "min-date"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("product.alertAt")), 1),
                  _createVNode(_component_Calendar, {
                    modelValue: _unref(form).stockInput.alertAt.$value,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).stockInput.alertAt.$value) = $event)),
                    dateFormat: _ctx.$t('format.calShort'),
                    placeholder: _ctx.$t('format.calShort'),
                    "year-navigator": true,
                    id: "alertAt",
                    "min-date": _unref(minDate)
                  }, null, 8, ["modelValue", "dateFormat", "placeholder", "min-date"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("product.threshold")), 1),
                  _createVNode(_component_InputNumber, {
                    modelValue: _unref(form).threshold.$value,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(form).threshold.$value) = $event)),
                    locale: _unref(numberSeparators)[_unref(activeActivity).separator],
                    "max-fraction-digits": 20,
                    min: 0,
                    "allow-empty": false,
                    mode: "decimal",
                    id: "threshold"
                  }, null, 8, ["modelValue", "locale"])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(ImageCropper, {
            ref_key: "cropperRef",
            ref: cropperRef,
            height: 300,
            modelValue: _unref(image),
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(image) ? (image).value = $event : null))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_Button, {
            label: _ctx.$t('reset'),
            icon: "pi pi-refresh",
            class: "p-button-outlined",
            style: {"width":"100%"},
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(resetFields)()))
          }, null, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_Button, {
            label: _ctx.$t('validate'),
            icon: "pi pi-send",
            class: "p-button-outlined",
            type: "submit",
            disabled: !canCreate.value,
            loading: _unref(loading),
            style: {"width":"100%"}
          }, null, 8, ["label", "disabled", "loading"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["blocked"]))
}
}

})